import { MessageCircle } from "lucide-react";
import { Logo } from "./Logo";
import { WHATSAPP_URL, WHATSAPP_NUMBER, scrollToSection } from "@/lib/site";

export const Footer = () => (
  <footer data-testid="footer" className="border-t border-slate-200 bg-[#F8FAFC]">
    <div className="mx-auto flex max-w-6xl flex-col gap-10 px-5 py-14 md:flex-row md:justify-between">
      <div className="max-w-sm">
        <Logo />
        <p className="mt-4 text-sm leading-relaxed text-slate-600">
          Carte ed espositori NFC e QR Code per raccogliere recensioni a 5 stelle su Google, valorizzare i nuovi
          clienti e fidelizzare quelli di sempre.        </p>
      </div>
      <div>
        <h4 className="font-display text-sm font-bold uppercase tracking-widest text-slate-900">Navigazione</h4>
        <ul className="mt-4 flex flex-col gap-2.5 text-sm text-slate-600">
          <li><button data-testid="footer-link-how" onClick={() => scrollToSection("#come-funziona")} className="transition-colors hover:text-[#4285F4]">Come funziona</button></li>
          <li><button data-testid="footer-link-benefits" onClick={() => scrollToSection("#benefici")} className="transition-colors hover:text-[#4285F4]">Perché conviene</button></li>
          <li><button data-testid="footer-link-products" onClick={() => scrollToSection("#prodotti")} className="transition-colors hover:text-[#4285F4]">Prodotti</button></li>
          <li><button data-testid="footer-link-faq" onClick={() => scrollToSection("#faq")} className="transition-colors hover:text-[#4285F4]">FAQ</button></li>
        </ul>
      </div>
      <div>
        <h4 className="font-display text-sm font-bold uppercase tracking-widest text-slate-900">Contatti</h4>
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-whatsapp-link"
          className="mt-4 flex items-center gap-2 text-sm font-semibold text-[#1EBE5D] transition-colors hover:text-[#25D366]"
        >
          <MessageCircle className="h-4 w-4" /> WhatsApp: {WHATSAPP_NUMBER}
        </a>
        <p className="mt-3 text-sm text-slate-500">Rispondiamo in pochi minuti, 7 giorni su 7.</p>
      </div>
    </div>
    <div className="border-t border-slate-200 py-6 text-center text-xs text-slate-400">
      <p>© {new Date().getFullYear()} TapGoogle.com — Tutti i diritti riservati.</p>
      <p className="mt-1">Google è un marchio di Google LLC. TapGoogle.com non è affiliata né sponsorizzata da Google.</p>
    </div>
  </footer>
);
